import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || "",
  },
  getters: {
    getToken: (state) => {
      return state.token;
    },
  },
  mutations: {
    setToken(state, token: string) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    clearToken(state) {
      state.token = "";
      localStorage.removeItem("token");
    },
  },
  actions: {
    saveToken({ commit }, token: string) {
      commit("setToken", token);
    },
    logout({ commit }) {
      commit("clearToken");
    },
  },
  modules: {},
});
